export enum QueryParamKeys {
  authCode = 'auth_code',
  authUri = 'auth_uri',
  embedded = 'embedded',
  ref = 'ref',
  referrer = 'referrer',
  sessionId = 'sessionId',
  tenantId = 'tenantId',
}
